var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityOffBlack24Dp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 47.333 43.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "visibility_off_black_24dp_svg__Path_871",
    x: 0,
    y: 0,
    width: 47.333,
    height: 43.533,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visibility_off_black_24dp_svg__visibility_off_black_24dp",
    transform: "translate(7.667 2.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visibility_off_black_24dp_svg__Path_870",
    "data-name": "Path 870",
    d: "M0,0H32V32H0ZM0,0H32V32H0ZM0,0H32V32H0ZM0,0H32V32H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.67, -2.73)",
    filter: "url(#visibility_off_black_24dp_svg__Path_871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visibility_off_black_24dp_svg__Path_871-2",
    "data-name": "Path 871",
    d: "M15.667,7.183a13.027,13.027,0,0,1,11.76,7.333,12.862,12.862,0,0,1-3.213,4.16l1.88,1.88a15.736,15.736,0,0,0,4.24-6.04,15.778,15.778,0,0,0-19.52-9.24l2.2,2.2A13.477,13.477,0,0,1,15.667,7.183ZM14.24,8.7,17,11.463a3.331,3.331,0,0,1,1.707,1.707l2.76,2.76a6.239,6.239,0,0,0,.187-1.427,5.978,5.978,0,0,0-5.987-5.987A5.659,5.659,0,0,0,14.24,8.7ZM2.347,4.343,5.92,7.917A15.65,15.65,0,0,0,1,14.517a15.769,15.769,0,0,0,14.667,10,15.64,15.64,0,0,0,5.76-1.093l4.56,4.56,1.88-1.88L4.227,2.45Zm10,10,3.48,3.48a.669.669,0,0,1-.16.027,3.335,3.335,0,0,1-3.333-3.333C12.333,14.45,12.347,14.41,12.347,14.343ZM7.813,9.81l2.333,2.333a6.134,6.134,0,0,0-.48,2.373,6.007,6.007,0,0,0,8.36,5.52l1.307,1.307a13.91,13.91,0,0,1-3.667.507,13.027,13.027,0,0,1-11.76-7.333A13.2,13.2,0,0,1,7.813,9.81Z",
    transform: "translate(8 3.55)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffBlack24Dp);
export default __webpack_public_path__ + "static/media/visibility_off_black_24dp.3bf34d5d57c11813964f67d128b6e961.svg";
export { ForwardRef as ReactComponent };